module.exports = __webpack_public_path__ + "media/directory/settings_icon_hover-78b50959.svg";